/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import FileContentResult from "./FileContentResult";

const urls = {
    getInterpolation(programId: number, amendment: string, year: string): string {
        return queryUrl("/interpolation/getinterpolation", {programId, amendment, year});
    }
}

export default {
    urls,
    getInterpolation(programId: number, amendment: string, year: string): Promise<FileContentResult> {
        return contentOnly(Axios.get(queryUrl("/interpolation/getinterpolation", {programId, amendment, year}), defaultConfig));
    }
}
